module.exports = __webpack_public_path__ + "media/images/admin/icons/fast-forward-06a30349b748ce22f89e44e248bcf047.svg";